/**
 * The admin app's configured base URL, e.g. `https://app.alpharun.com`. Links
 * meant for someone else are built on it rather than on `window.location`,
 * because a tab on a company's service access origin must never hand out a
 * link to that origin.
 */
export const appBaseUrl = import.meta.env.VITE_ADMIN_APP_BASE_URL;

/** The HQ app's base URL, e.g. `https://hq.alpharun.com`. */
export const hqBaseUrl = import.meta.env.VITE_HQ_APP_BASE_URL;

/**
 * The absolute URL of `path` (with any query and fragment) on the admin app's
 * configured base URL, for a link that is copied or shared.
 */
export function buildAppUrl(path: string) {
  return new URL(path, appBaseUrl).toString();
}
